import { FC } from 'react';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useIncentivesMarketAdminPanel } from './context/IncentivesMarketAdminPanelContext';

import IncentivesMarketAdminPanelHeader from './components/IncentivesMarketAdminPanelHeader';
import IncentivesMarketAdminPanelSummaryCard from './components/IncentivesMarketAdminPanelSummaryCard';
import IncentivesMarketAdminPanelOffersList from './components/IncentivesMarketAdminPanelOffersList';

import '../../styles/IncentivesMarket.scss';

const IncentivesMarketAdminPanel: FC = () => {
  const { data, actions } = useIncentivesMarketAdminPanel();

  return (
    <Page id="incentives-market-admin-panel-page">
      <IncentivesMarketAdminPanelHeader
        societyId={data.societyId}
        societyName={data.societyName}
        incentivesMarketStatus={data.incentivesMarketStatus}
        onIncentivesMarketStatusChange={actions.handleIncentivesMarketStatusChange}
      />

      <IncentivesMarketAdminPanelSummaryCard
        sellOffersSummary={data.sellOffersSummary}
        buyOffersSummary={data.buyOffersSummary}
        pendingOperationsCount={data.pendingOperationsCount}
        sellOffers={data.sellOffers}
        buyOffers={data.buyOffers}
        operations={data.operations}
      />

      <div className="nk-block">
        <IncentivesMarketAdminPanelOffersList
          societyId={data.societyId}
          sellOffers={data.sellOffers}
          buyOffers={data.buyOffers}
          operations={data.operations}
          onViewOfferDetail={actions.handleViewOfferDetail}
          onViewOperationDetail={actions.handleViewOperationDetail}
          onUpdateOperationStatus={actions.handleUpdateOperationStatus}
          onToggleBeneficiaryAccess={actions.handleTogglePartnerIncentivesMarketAccess}
          isLoading={data.isLoading}
        />
      </div>

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default IncentivesMarketAdminPanel;
